import { Col, Row } from "react-bootstrap";
import { useLoyalty } from "../../context";
import { useAuth, useStore } from "../../hooks";
import { formatCurrency } from "../../utilities";
import { BsTrophy, BsGiftFill, BsStars, BsArrowRight } from "react-icons/bs";

const LoyaltyPointsCard = () => {
  const { customer } = useAuth();
  const { loyaltyLevels } = useStore();
  const { currentLevel, loyaltyPoints, loyaltyAmount } = useLoyalty();

  const levels = loyaltyLevels as any[];
  const nextLevel = levels?.[Number(currentLevel)];

  const pointsRequired = Number(nextLevel?.points ?? 0);
  const pointsToGo = Math.max(pointsRequired - Number(loyaltyPoints), 0);
  const progressPercent = pointsRequired
    ? Math.min((Number(loyaltyPoints) / pointsRequired) * 100, 100)
    : 0;

  return (
    <>
      <div className="offer_reward_banner loyalty_banner">
        <Row className="g-4 align-items-stretch">
          <Col lg={8} className="d-flex">
            <div className="offer_reward_bann h-100 w-100">
              <Row className="h-100 g-0">
                {/* Trophy Column */}
                {/* <Col
                  lg={2}
                  className="trophy_section d-flex align-items-center justify-content-center"
                >
                  <div className="trophy_circle">
                    <BsTrophy />
                  </div>
                </Col> */}

                {/* Welcome User */}
                <Col lg={3}>
                  <div className="welcome_info h-100 d-flex flex-column trophy_section align-items-center justify-content-center">
                    <span className="welcome_text">Welcome back,</span>

                    <h3>{customer?.first_name}</h3>

                    <div className="trophy_circle">
                      <BsTrophy />
                    </div>

                    <div className="member_since mt-auto">
                      <span>Member since</span>
                      <strong>{customer?.create_ts}</strong>
                    </div>
                  </div>
                </Col>

                {/* Points Balance */}
                <Col lg={4}>
                  <div className="loyalty_bann h-100 d-flex flex-column justify-content-between">
                    <div>
                      <h5>Your Points Balance</h5>

                      <h2 className="points_balance_value">
                        {loyaltyPoints}
                        <span> Points</span>
                      </h2>

                      <p className="points_balance_amount">
                        = {formatCurrency(Number(loyaltyAmount))} in rewards
                      </p>
                    </div>

                    <button className="btn_redeem_rewards">
                      <BsGiftFill size={20} />
                      Redeem Rewards
                    </button>
                  </div>
                </Col>

                {/* Next Reward */}
                <Col lg={4}>
                  <div className="next_reward_colm h-100 d-flex flex-column justify-content-between">
                    <div>
                      <h5 className="reward_title">
                        Next Reward <BsGiftFill />
                      </h5>

                      <h3>{nextLevel?.name ?? "Keep earning"}</h3>

                      {pointsRequired > 0 && (
                        <p className="next_reward_points">
                          {pointsRequired} Points
                        </p>
                      )}

                      <div className="reward_progress_bar">
                        <div
                          className="reward_progress_bar_fill"
                          style={{ width: `${progressPercent}%` }}
                        />
                      </div>

                      <span className="reward_points_left">
                        {pointsToGo} points to go
                      </span>
                    </div>

                    <a href="#" className="view_rewards_link">
                      View available rewards
                      <BsArrowRight />
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={4} className="d-flex">
            <div className="how_it_works_card h-100 w-100 d-flex flex-column justify-content-between">
              <div>
                <h4>How it works</h4>
                <ul className="how_it_works_list list-unstyled">
                  <li className="d-flex align-items-start gap-2">
                    <BsGiftFill />
                    <div>
                      <h6>Earn point for every spent</h6>
                      <p>Points are added after order completion</p>
                    </div>
                  </li>
                  <li className="d-flex align-items-start gap-2">
                    <BsGiftFill />
                    <div>
                      <h6>Redeem your points</h6>
                      <p>Use points for discounts and free items</p>
                    </div>
                  </li>
                  <li className="d-flex align-items-start gap-2">
                    <BsStars />
                    <div>
                      <h6>Exclusive member benefits</h6>
                      <p>Unlock special offers and more</p>
                    </div>
                  </li>
                </ul>
              </div>
              <a
                href="#"
                className="view_terms_link d-flex align-items-center gap-1"
              >
                View program terms &amp; conditions <BsArrowRight />
              </a>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default LoyaltyPointsCard;
